const selector = 'bit';

export default class Bit {

	static selector = selector;

}
